/**
 * Enumération définissant les types de nature DECI
 */
enum TYPE_NATURE_DECI {
  PRIVE = "PRIVE",
  PUBLIC = "PUBLIC",
  CONVENTIONNE = "CONVENTIONNE",
  ICPE = "ICPE",
  ICPE_CONVENTIONNE = "ICPE_CONVENTIONNE",
}
export default TYPE_NATURE_DECI;
